import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function clamp(value: number, min: number, max: number) {
	return Math.min(Math.max(value, min), max);
}

export function easeOut(value: number) {
	return 1 - (1 - value) ** 2.2;
}

export function transition(updateCallback: () => void) {
	if (typeof document !== "undefined" && "startViewTransition" in document) {
		document.startViewTransition(updateCallback);
	} else {
		updateCallback();
	}
}

// @ts-expect-error : no ts module
import writtenNumber from "written-number";
export function convertNumberToWords(num: number) {
	return writtenNumber(num, { lang: "en" });
}
